<template>
    <b-card class="microportal text-center h-100" :class="cardClasses">
        <i :class="icon"/>
        <h3 class="text-uppercase">
            {{ label }}
            <slot name="label"/>
        </h3>
        <b-link v-if="to" class="card-link stretched-link" :to="to"/>
        <a v-if="typeof(clickHandler) === 'function'" class="card-link stretched-link"
            href="#" @click.prevent="clickHandler"/>
    </b-card>
</template>

<script>
    export default {
        props: {
            active: {
                type: Boolean,
                default: false,
            },
            clickHandler: {
                type: [Function, Boolean],
                default: false,
            },
            icon: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: '',
            },
            to: {
                type: [String, Object],
                default: null,
            },
        },
        computed: {
            cardClasses() {
                const classes = [];
                if (this.active) {
                    classes.push('active');
                }
                if (this.size) {
                    classes.push(this.size);
                }
                return classes;
            },
        },
    }
</script>
